import { render, staticRenderFns } from "./DetailedTK.vue?vue&type=template&id=1387bbca&scoped=true"
import script from "./DetailedTK.vue?vue&type=script&lang=js"
export * from "./DetailedTK.vue?vue&type=script&lang=js"
import style0 from "./DetailedTK.vue?vue&type=style&index=0&id=1387bbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387bbca",
  null
  
)

export default component.exports